/* eslint-disable no-useless-constructor,react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';

import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';

import TaskExecLogsBlock from '../TaskExecLogsBlock';
import TasksExecsFormsBlockAsOwner from '../../../TasksExecsForms/TasksExecsFormsBlockAsOwner';
import TasksExecsFormsBlockAsExecutor from '../../../TasksExecsForms/TasksExecsFormsBlockAsExecutor';
import DeadlineTimer from '../../../../Common/DeadlineTimer';

class TaskExecLightItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let titleIconClass = null;
    let typeContextClass = null;
    switch (this.props.exec.status) {
      case 1: {
        titleIconClass = 'fa fa-play-circle';
        typeContextClass = 'text-success';
        break;
      }
      case 2: {
        titleIconClass = 'fa fa-file-text';
        typeContextClass = 'text-info';
        break;
      }
      case 3: {
        titleIconClass = 'fa fa-times-circle';
        typeContextClass = 'text-danger';
        break;
      }
      case 4: {
        titleIconClass = 'fa fa-check-circle';
        typeContextClass = 'text-success';
        break;
      }
      case 5: {
        titleIconClass = 'fa fa-times-circle';
        typeContextClass = 'text-danger';
        break;
      }
      case 6: {
        titleIconClass = 'fa fa-times-circle';
        typeContextClass = 'text-danger';
        break;
      }
      case 7: {
        titleIconClass = 'fa fa-gavel';
        typeContextClass = 'text-warning';
        break;
      }
      default:
        break;
    }
    const timerDeadline = () => {
      if ([1, 3].includes(this.props.exec.status)) {
        return (
          <span
            className="text-muted"
            data-toggle="tooltip"
            data-placement="right"
            data-original-title={t('Оставшееся время на выполнение задания')}
          >
            | <i className="fa fa-clock-o" />{' '}
            <DeadlineTimer
              key={`deadlinePerformTime-${this.props.exec.id}`}
              secondsLeft={this.props.exec.deadlinePerformTimer}
            />
          </span>
        );
      } else if ([2].includes(this.props.exec.status)) {
        return (
          <span
            className="text-muted"
            data-toggle="tooltip"
            data-placement="right"
            data-original-title={t('Оставшееся время на проверку задания')}
          >
            | <i className="fa fa-clock-o" />{' '}
            <DeadlineTimer
              key={`deadlineCheckedTime-${this.props.exec.id}`}
              secondsLeft={this.props.exec.deadlineCheckedTimer}
            />
          </span>
        );
      }
      return null;
    };
    return (
      <article className="panel panel-default panel-body_bg-gray panel-footer_padding-large">
        <div className="panel-heading">
          <div className="media">
            <div className="media-left">
              <NavLink
                to={`/users/profile/${this.props.exec.ownerId}`}
                title={this.props.exec.ownerId}
              >
                <img
                  alt=""
                  className="media-object avatar avatar-sm"
                  src={this.props.exec.ownerAvatarPath}
                />
              </NavLink>
            </div>
            <div className="media-body media-middle">
              <div>
                <NavLink
                  to={`/users/profile/${this.props.exec.ownerId}`}
                  title={this.props.exec.ownerId}
                >
                  <strong>{this.props.exec.ownerName}</strong>
                </NavLink>
              </div>
              <div className="text-caption">
                <span className="text-muted">ID{this.props.exec.id}</span>{' '}
                <span className={`${typeContextClass}`}>
                  <i className={`${titleIconClass}`} />{' '}
                  {this.props.exec.statusName}
                </span>{' '}
                {timerDeadline()}
              </div>
            </div>
          </div>
        </div>
        <div className="panel-body border-simple-b">
          <TaskExecLogsBlock execId={this.props.exec.id} />
        </div>
        {this.props.authUserId === this.props.exec.ownerId ? (
          <TasksExecsFormsBlockAsExecutor {...this.props} />
        ) : (
          <TasksExecsFormsBlockAsOwner {...this.props} />
        )}
      </article>
    );
  }
}

TaskExecLightItem.propTypes = {
  // IN
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ownerId: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    statusName: PropTypes.string.isRequired,
    ownerName: PropTypes.string,
    ownerAvatarPath: PropTypes.string,
    deadlinePerformTimer: PropTypes.number,
    deadlineCheckedTimer: PropTypes.number,
    lastExecLog: PropTypes.shape.isRequired
  }).isRequired,

  // CONNECT
  authUserId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  authUserId: selectUserId(state)
});

export default withRouter(connect(mapStateToProps)(TaskExecLightItem));



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLightItem/TaskExecLightItem.js